/* bootloader, loads on click event*/	
const EditAddressBlueBox = function(){ 
	const forms = new forms4i();
	const maps = new maps4i();
	const common = new bbCommon();
	const addressDialog = new Dialog4i();
	const loadingIcon = 
		'<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading edit address dialog, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
	const bbModel = common.bbModel;
	const editAddressLink = document.getElementById("editAddressLink");
	let companyInput, address1Input, address2Input, address3Input, cityInput, stateInput, zipInput;
	
	const init = () => {
		addressDialog.Init({
			triggerElements: editAddressLink,
			dialogClass: "mediumDialog", 
			title: "Delivery Address",
			content: loadingIcon, 
			onOpen: updateContent
		}); 
	};
	
	const updateContent = async () =>{   
		common.FixBoxModel(bbModel);
		let responseHTML;
	 	try {
      			const response = await fetch('/bluebox/GetEditAddress', {
        			method: 'POST',
        			credentials: 'same-origin',
        			body: JSON.stringify(bbModel),
        			headers: {
          				'Content-Type': 'application/json',
          				'X-Requested-With': 'fetch',
          				'RequestVerificationToken': common.HeaderToken,
         	 			'__RequestVerificationToken': common.HeaderToken
        			}
      			});

      			//if (!response.ok) throw new Error('Error fetching edit address data');
			responseHTML = await response.text();
    		} catch (error) {
      			formError();
			console.log(error);
    		}
    		
    		if(responseHTML) addFormToDialog(responseHTML);
	};
	
	const addFormToDialog = (form) =>{
		const dialogContent = document.getElementById("popUpDialog").querySelector(".dialogContent");
 		dialogContent.innerHTML = form;
		maps.init();
		dialogContent.addEventListener("click", addressEvents);
	};
	
	const formError = () =>{
		const dialogContent = document.getElementById("popUpDialog").querySelector(".dialogContent");
		const error = 
			'<p class="text16 marginBtm10" role="alert" aria-atomic="true">Oops! There was an error getting your form. Please close this dialog and try again. If this continues, please <a href="/info/contactus">contact us</a>.</p>';
      		dialogContent.innerHTML = error;
	};
	
	const addressEvents = (e) => {
		if(e.target.id == "saveAddressChange"){
			e.preventDefault();
			const editAddressForm = document.getElementById("editAddress");
			forms.formValidation(editAddressForm, changeAddress, e);
		}else if(e.target.id == "cancelAddressChange"){
			e.preventDefault();
			addressDialog.Close();
		}
	};
   	
	const updateDisplay = (field, fieldDisplay, resultDisplay) =>{
		if (field.trim() == "") { 
			if (fieldDisplay) fieldDisplay.classList.add("hide"); 
			if (resultDisplay) resultDisplay.classList.add("hide"); 
		}else {
			if(fieldDisplay){
				fieldDisplay.classList.remove("hide");
				fieldDisplay.innerHTML = field;
			}
			if (resultDisplay){
				resultDisplay.classList.remove("hide");
				resultDisplay.innerHTML = field;
			}
		}
	};
	
	const changeAddressDisplay = () =>{		
		const successMsgDisplay = document.querySelector(".addySuccess");
		if(successMsgDisplay) successMsgDisplay.remove();
		getFormInputs();

		const company = companyInput ? companyInput.value : "";
		updateDisplay(company, document.getElementById("companyDisplay"), document.getElementById("resultCompanyDisplay"));
		
		const addr1 = address1Input ? address1Input.value : "";
		const addr1Display = document.getElementById("addr1Display");
		const resultAddr1Display = document.getElementById("resultAddr1Display");
		if (addr1Display && addr1.trim() != "") addr1Display.innerHTML = addr1;
		if (resultAddr1Display && addr1.trim() != "") resultAddr1Display.innerHTML = addr1;
		
		const addr2 = address2Input ? address2Input.value : "";
		updateDisplay(addr2, document.getElementById("addr2Display"), document.getElementById("resultAddr2Display"));
		
		const addr3 = address3Input ? address3Input.value : "";
		updateDisplay(addr3, document.getElementById("addr3Display"), document.getElementById("resultAddr3Display"));
		
		const city = cityInput ? cityInput.value : "";
		const cityDisplay = document.getElementById("cityDisplay");
		const resultCityDisplay = document.getElementById("resultCityDisplay");
		if (cityDisplay && city.trim() != "") cityDisplay.innerHTML = city;
		if (resultCityDisplay && city.trim() != "") resultCityDisplay.innerHTML = city;

		const state = stateInput ? stateInput.value : "";
		updateDisplay(state, document.getElementById("stateDisplay"), document.getElementById("resultStateDisplay"));
		
		const zipcode = zipInput ? zipInput.value : "";
		const zipcodeDisplay = document.getElementById("zipcodeDisplay");
		const resultZipcodeDisplay = document.getElementById("resultZipcodeDisplay");
		if (zipcodeDisplay && zipcode.trim() != "") zipcodeDisplay.innerHTML = zipcode;
		if (resultZipcodeDisplay && zipcode.trim() != "") resultZipcodeDisplay.innerHTML = zipcode;
					
		addressDialog.Close();		
		const successMsg = 
			'<p class="addySuccess textSemiBold text16 marginTop5 textDarkestGray displayFlex flexNoWrap flexAlignItemsCenter" role="alert" aria-atomic="true"><svg class="textDarkestGray" height="20px" width="20px" role="img" aria-hidden="true"> <use xlink:href="#svgIcon-checkMark"></use> </svg> Address updated</p>';
        	document.getElementById("editAddressLink").insertAdjacentHTML("afterend", successMsg);
	};
	
	const getFormInputs = () =>{
		companyInput = document.getElementById("Company");
		address1Input = document.getElementById("Address1");
		address2Input = document.getElementById("Address2");
		address3Input = document.getElementById("Address3");
		cityInput = document.getElementById("City");
		stateInput = document.getElementById("State");
		zipInput = document.getElementById("Zipcode");
	};
	
	const changeAddress = async () =>{
		const submitBtn = document.getElementById("submitChangeAddress");
    		const saveBtn = document.getElementById("saveAddressChange");
    		submitBtn.classList.remove("hide");
    		if (saveBtn) common.DisableBlueBtn(saveBtn);

    		getFormInputs();

    		bbModel.Company = companyInput ? companyInput.value : "";
    		bbModel.Address1 = address1Input ? address1Input.value : "";
    		bbModel.Address2 = address2Input ? address2Input.value : "";
    		bbModel.Address3 = address3Input ? address3Input.value : "";
    		bbModel.City = cityInput ? cityInput.value : "";
    		bbModel.State = stateInput ? stateInput.value : "";
    		bbModel.ZipCode = zipInput ? zipInput.value : "";
    		common.FixBoxModel(bbModel);
		let responseJSON;
    		try {
      			const response = await fetch('/bluebox/EditAddress', {
        			method: 'POST',
        			credentials: 'same-origin',
        			body: JSON.stringify(bbModel),
        			headers: {
          				'Content-Type': 'application/json',
          				'X-Requested-With': 'fetch',
          				'RequestVerificationToken': common.HeaderToken,
          				'__RequestVerificationToken': common.HeaderToken
        			}
      			});

      			//if (!response.ok) throw new Error('Error processing change address request');
			responseJSON = await response.json();
    		} catch (error) {
      			common.DisplayStatusMsg();
			console.log(error);
    		}
    		
    		if(responseJSON){
    			if (responseJSON.success) changeAddressDisplay();
      			else editAddressFail();
    		}
	};
	
	const editAddressFail = () =>{
		const editError = document.getElementById("editAddressError");
		const changeError = 
			'<div class="errorMessage text16 textDkRed textSemiBold marginBtm10" role="alert">Your delivery address could not be changed. Please try again later.</div>';
		editError.innerHTML = changeError;
		const submitBtn = document.getElementById("submitChangeAddress");
		const saveBtn = document.getElementById("saveAddressChange");
		if (submitBtn) submitBtn.classList.add("hide");
		if (saveBtn) common.EnableBlueBtn(saveBtn);
	};
	
	return{
		Init: init
	};
};

(async () => {
	const editAddressDialog = new EditAddressBlueBox();
	editAddressDialog.Init();
	document.getElementById("editAddressLink").click();
})();